import React from 'react';

const Office: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.66665C9 1.11437 9.44772 0.666654 10 0.666654H30C30.5523 0.666654 31 1.11437 31 1.66665V9.99999C31 10.5523 30.5523 11 30 11C29.4477 11 29 10.5523 29 9.99999V2.66665H11V15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15V1.66665Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6667 38.3333C15.6667 37.781 16.1145 37.3333 16.6667 37.3333H23.3334C23.8857 37.3333 24.3334 37.781 24.3334 38.3333C24.3334 38.8856 23.8857 39.3333 23.3334 39.3333H16.6667C16.1145 39.3333 15.6667 38.8856 15.6667 38.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666748 20C0.666748 19.4477 1.11446 19 1.66675 19H16.6667C17.219 19 17.6667 19.4477 17.6667 20V38.3333C17.6667 38.8856 17.219 39.3333 16.6667 39.3333H1.66675C1.11446 39.3333 0.666748 38.8856 0.666748 38.3333V20ZM2.66675 21V37.3333H15.6667V21H2.66675Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3335 15C22.3335 14.4477 22.7812 14 23.3335 14H38.3335C38.8858 14 39.3335 14.4477 39.3335 15V38.3333C39.3335 38.8856 38.8858 39.3333 38.3335 39.3333H23.3335C22.7812 39.3333 22.3335 38.8856 22.3335 38.3333V15ZM24.3335 16V37.3333H37.3335V16H24.3335Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 21.6667C29 21.1144 29.4477 20.6667 30 20.6667H31.6667C32.219 20.6667 32.6667 21.1144 32.6667 21.6667C32.6667 22.2189 32.219 22.6667 31.6667 22.6667H30C29.4477 22.6667 29 22.2189 29 21.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 26.6667C29 26.1144 29.4477 25.6667 30 25.6667H31.6667C32.219 25.6667 32.6667 26.1144 32.6667 26.6667C32.6667 27.2189 32.219 27.6667 31.6667 27.6667H30C29.4477 27.6667 29 27.2189 29 26.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 31.6667C29 31.1144 29.4477 30.6667 30 30.6667H31.6667C32.219 30.6667 32.6667 31.1144 32.6667 31.6667C32.6667 32.2189 32.219 32.6667 31.6667 32.6667H30C29.4477 32.6667 29 32.2189 29 31.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3335 31.6667C7.3335 31.1144 7.78121 30.6667 8.3335 30.6667H10.0002C10.5524 30.6667 11.0002 31.1144 11.0002 31.6667C11.0002 32.2189 10.5524 32.6667 10.0002 32.6667H8.3335C7.78121 32.6667 7.3335 32.2189 7.3335 31.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3335 26.6667C7.3335 26.1144 7.78121 25.6667 8.3335 25.6667H10.0002C10.5524 25.6667 11.0002 26.1144 11.0002 26.6667C11.0002 27.2189 10.5524 27.6667 10.0002 27.6667H8.3335C7.78121 27.6667 7.3335 27.2189 7.3335 26.6667Z"
      />
    </svg>
  );
};

export default Office;
